import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  
} from "react-router-dom";
import Home from './Home'
import Navbar from './Navbar'
import Events from './Events';
import Sponsers from './Sponsers'
import Contactus from './Contactus'

function App() {
  return (
        <Router>
            <Navbar/>
            <Routes>
                
                <Route exact path="/" element={<Home />}>
                
                </Route>
                <Route exact path="/events" element={<Events />}>
                
                </Route>
                <Route exact path="/sponsers" element={<Sponsers />}>
                
                </Route>
                <Route exact path="/contactus" element={<Contactus />}>
                
                </Route>
                
            </Routes>
            
        </Router>
  );
}

export default App;
